import { Box, Container, Grid, Paper, Typography } from "@mui/material";
import React from "react";
import coreFeature from "../../images/core-feature.png";
import smartFeature from "../../images/smart-feature-icon-2.svg";
import secure from "../../images/secure-icon.svg";

const CoreFeatures = () => {
  return (
    <div>
      <Container sx={{ py: 6 }}>
        <Box sx={{ flexGrow: 1 }}>
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 2, sm: 8, md: 12 }}
          >
            <Grid item xs={2} sm={4} md={6}>
              <Box>
                <img className="core-feature-img" src={coreFeature} alt="" />
              </Box>
            </Grid>
            <Grid sx={{ mt: { xs: 0, md: 8 } }} item xs={2} sm={4} md={6}>
              <Box sx={{ textAlign: { xs: "center", md: "left" } }}>
                <Typography className="sub-title" variant="subtitle1">
                  Core features
                </Typography>
                <Typography
                  sx={{ fontSize: 48, mt: 2, width: { xs: 1, md: "70%" } }}
                  className="section-title"
                  variant="h3"
                >
                  Smart Jackpots that you may love this anytime & anywhere
                </Typography>
              </Box>
              <Box>
                <Paper
                  sx={{
                    p: 3,
                    boxShadow: 0,
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    gap: { xs: 2, md: 4 },
                    my: 2,
                    textAlign: { xs: "center", md: "inherit" },
                  }}
                >
                  <img className="feature-img" src={smartFeature} alt="" />
                  <Box>
                    <Typography
                      sx={{ fontSize: 18, fontWeight: 700, my: 2 }}
                      variant="h4"
                    >
                      Smart Features
                    </Typography>
                    <Typography variant="body1">
                      Get your blood tests delivered at let home collect sample
                      from the victory of the managments.your blood tests.
                    </Typography>
                  </Box>
                </Paper>
                <Paper
                  sx={{
                    p: 3,
                    boxShadow: 0,
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    gap: { xs: 2, md: 4 },
                    my: 2,
                    textAlign: { xs: "center", md: "inherit" },
                  }}
                >
                  <img className="feature-img" src={secure} alt="" />
                  <Box>
                    <Typography
                      sx={{ fontSize: 18, fontWeight: 700, my: 2 }}
                      variant="h4"
                    >
                      Secure Contents
                    </Typography>
                    <Typography variant="body1">
                      Get your blood tests delivered at let home collect sample
                      from the victory of the managments.your blood tests.
                    </Typography>
                  </Box>
                </Paper>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </div>
  );
};

export default CoreFeatures;
